import React from "react";
import { Button } from "primereact/button";

const AbrirPDFPopup = ({ link }) => {
  const abrirPDF = () => {
    
    const id = link.match(/id=([a-zA-Z0-9_-]+)/)[1];
    const url = `https://drive.google.com/file/d/${id}/view`;  
    window.open(url, "_blank");
  };

  return (
    <div>
      <Button
        label="Visualizar"
        icon="fa fa-file-pdf"
        className="bg-lightBlue-600 mx-4 text-white px-3 py-1 rounded-md shadow hover:bg-lightBlue-500"
        onClick={abrirPDF}
      />
    </div>
  );
};

export default AbrirPDFPopup;
